import React, { useEffect, useState } from "react";
import Loadspinner from "../../common/Loadspinner";
import Main from "../../common/Main/Main";
import UsefulLinksService from "../../services/UsefulLinksService";

import LanguageIcon from "@material-ui/icons/Language";

import { experimentalStyled as styled } from "@mui/material/styles";
import { Box, Paper, Grid, Typography, Avatar } from "@mui/material";
import Base64ImageRender from "../../common/Base64ImageRender";
import { APICall } from "../../helpers/API/APICalls";
import { getAllUsefulLinkData } from "../../helpers/API/APIEndPoints";
import { downloadBlob } from "../../services/CommonService";
import { replaceImgAccountName } from "../../helpers/Utils/Utils";

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(2),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

function UsefulLinks() {
  const [loading, setLoading] = useState(false);
  const [usefulLinkList, setusefulLinkList] = useState([]);
  const [pageSize, setPageSize] = useState(Number.MAX_SAFE_INTEGER);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("Sequence");
  const [sortDirection, setSortDirection] = useState("asc");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);

  useEffect(() => {
    getBookmarks();
  }, []);

  const getBookmarks = async () => {
    setLoading(true);
    // const res = await UsefulLinksService.usefulLinks();

    // if (res) {
    //   setusefulLinkList(res);

    // }
    let requestParams = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      isExport: false,
    };
    let res = await APICall(getAllUsefulLinkData, requestParams);
    if (res.message === "Ok") {
      if (res && res.data.length > 0) {
        // await res.data.map(async (res) => {
        //   if (res.Image !== "") {
        //     res.Image = await downloadBlob(res.Image);
        //   }
        //   return res;
        // });
        let oldData = res.data;
        oldData.forEach((od) => replaceImgAccountName(od?.Image));
        console.log(oldData);
        setusefulLinkList(oldData);
        setCount(res.totalCount);
      }
    }

    setLoading(false);
  };

  console.log(usefulLinkList);
  // const getFilteredLinks = async (e) => {
  //   let searchData = {
  //     search: e.target.value,
  //   };
  //   setLoading(true);
  //   const res = await UsefulLinksService.usefulLinkSearch(searchData);
  //   if (res) {
  //     setusefulLinkList(res);
  //   }
  //   setLoading(false);
  // };

  const handleClick = (event) => {
    const { href } = event.currentTarget;

    try {
      new URL(href);
    } catch (error) {
      event.preventDefault(); // Prevent the default behavior of the anchor tag
      console.error("Invalid URL:", href);
    }
  };

  return (
    <Main active={"usefull_links"}>
      <Loadspinner filename="UsefulLinks.js" isLoading={loading} isMiddle="false" />
      <h5 style={{ marginBottom: "15px", marginTop: "15px" }}>Useful links</h5>
      <Box sx={{ width: "71vw" }}>
        <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 4 }}>
          {usefulLinkList.length > 0
            ? usefulLinkList.map((link) => {
              return (
                <Grid item md={3} key={link.Id} style={{ marginTop: "7px " }}>
                  <a
                    href={link.QuickLink}
                    target="_blank"
                    rel="noreferrer"
                    onClick={handleClick}
                  >
                    <Item style={{ borderRadius: "20px" }}>
                      <Typography>
                        <div style={{ height: "5vw" }}>
                          {link.Image != "" && link.Image != null ? (
                            <Base64ImageRender url={link.Image} />
                          ) : (
                            <LanguageIcon
                              style={{ color: "black", fontSize: "40px" }}
                            />
                          )}
                        </div>
                        <h6
                          style={{
                            margin: "15px 0 5px 0",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "black",
                          }}
                        >
                          {link.Title}
                        </h6>
                      </Typography>
                      {/* <Typography style={{ fontSize: "12px" }} noWrap>
                  {link.description}
                </Typography> */}
                    </Item>
                  </a>
                </Grid>
              );
            })
            : null}
        </Grid>
      </Box>
      {/* </div> */}
    </Main>
  );
}

export default UsefulLinks;
